/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import React from 'react';
import { formatDinheiro } from '../../utils/formatDinheiro';
import * as S from './ProdutoCarrinhoView.style';
import ButtonPrimary from 'components/Buttons/ButtonPrimary/ButtomPrimary.component';
import assets from '../../assets';

const ProdutoCarrinhoView = ({ id, produto, valor, quantidade, comissao, removerProduto }) => {
  const extra = produto.extra || {};
  const caracteristicas = produto?.caracteristicas || [];
  const [caracteristicaIndex, setCaracteristicaIndex] = useState(0);
  const [qtd, setQuantidade] = useState(quantidade);
  const [indexPicture, setIndexPicture] = useState(0);

  const handlePicture = (value: number) => {
    const qtdP = caracteristicas[caracteristicaIndex]?.fotos?.length - 1 || 0;

    let index = value + indexPicture;
    if (index > qtdP) index = 0;
    if (index < 0) index = qtdP;
    setIndexPicture(index);
  };

  return (
    <S.ContainerWrapperCalculadora>
      <S.ProdutoViewBox>
        <S.ImgProdutoBox>
          {produto?.caracteristicas[caracteristicaIndex]?.fotos[indexPicture]?.imagem ? (
            <img
              src={produto?.caracteristicas[caracteristicaIndex]?.fotos[indexPicture]?.imagem}
              alt={'Imagem do produto ' + produto?.[caracteristicaIndex]?.nome}
            />
          ) : (
            <img src={assets.images.produto} alt="Produto sem imagem definida!" />
          )}
          {produto.caracteristicas[caracteristicaIndex].fotos.length > 1 && (
            <S.BoxPreviewImg>
              <IconButton color="success" aria-label="foto anterior" onClick={() => handlePicture(1)}>
                <NavigateBeforeIcon />
              </IconButton>
              <IconButton color="success" aria-label="próxima foto" onClick={() => handlePicture(-1)}>
                <NavigateNextIcon />
              </IconButton>
            </S.BoxPreviewImg>
          )}
        </S.ImgProdutoBox>
        <S.TilteProduto>
          <p>{produto.nome}</p>
        </S.TilteProduto>
        <S.BoxTitleProduto></S.BoxTitleProduto>
        <S.BoxTamanhoProduto>
          {produto.largura} X {produto.altura} mm
        </S.BoxTamanhoProduto>
        <S.CoresTiTle>cor</S.CoresTiTle>
        <S.BoxVarianteCores>
          <S.BoxCores>
            <ul>
              <li>
                <label>
                  <input type="radio" name="color" value="1" />
                  <span className="swatch" style={{ background: extra?.hexadecimal || '#ffffff' }}></span>
                </label>
              </li>
            </ul>
          </S.BoxCores>
        </S.BoxVarianteCores>
      </S.ProdutoViewBox>
      <S.BoxCalculadora>
        <S.BoxTaxasOpcoes>
          <S.OpcoesWrapper>
            <S.BoxInputPrimario>
              <label>Estado</label>
              <select name="partilhaSelect" defaultValue={extra.estado} disabled>
                <option value={extra.estado}>{extra.estado}</option>
                <option value="naoContribuinte">Não Contribuinte</option>
              </select>
            </S.BoxInputPrimario>

            <S.BoxInputPrimario>
              <label>Partilha</label>
              <select name="partilhaSelect" defaultValue={extra.partilha} disabled>
                <option value="contribuinte">Contribuinte</option>
                <option value="naoContribuinte">Não Contribuinte</option>
              </select>
            </S.BoxInputPrimario>

            <S.BoxInputPrimario>
              <label>Tipo do Cliente</label>
              <select name="tipoCliente" defaultValue={extra.icms} disabled>
                <option value={'consumo'}>Consumo</option>
                <option value={'revenda'}>Revenda</option>
              </select>
            </S.BoxInputPrimario>

            <S.BoxInputPrimario>
              <label>Quantidade</label>
              <input type="number" name="qty" disabled value={qtd} />
            </S.BoxInputPrimario>
          </S.OpcoesWrapper>
          <S.BoxTaxasWrapper>
            <S.BoxInputSecundario>
              <label>ICMS</label>
              <input type="text" value={extra.icmsValor + '%'} disabled />
            </S.BoxInputSecundario>
            <S.BoxInputSecundario>
              <label>IPI</label>
              <input type="text" value={produto.ipi + '%'} disabled />
            </S.BoxInputSecundario>
            <S.BoxInputSecundario>
              <label>Partilha do Estado</label>
              <input type="text" value={extra.partilhaValor + '%'} disabled />
            </S.BoxInputSecundario>
            <S.BoxInputSecundario>
              <label>Frete</label>
              <input type="text" value={produto.frete + '%'} disabled />
            </S.BoxInputSecundario>
            <S.BoxInputSecundario>
              <label>Comissão</label>
              <input type="text" value={extra.comissao + '%'} disabled />
            </S.BoxInputSecundario>
          </S.BoxTaxasWrapper>
        </S.BoxTaxasOpcoes>
        <S.BoxAjusteWrapper>
          <S.BoxResultado>
            <S.BoxCalculadoraWrapper>
              <S.TitlePrefixo>Preço sugerido</S.TitlePrefixo>
              <S.ResultadoCalculo>{formatDinheiro(valor, 2)}</S.ResultadoCalculo>
            </S.BoxCalculadoraWrapper>
            <S.BoxCalculadoraWrapper>
              <S.TitlePrefixo>Preço c/ipi</S.TitlePrefixo>
              <S.ResultadoCalculo>{formatDinheiro(extra.valorIpi, 2)}</S.ResultadoCalculo>
            </S.BoxCalculadoraWrapper>
            <S.BoxCalculadoraWrapper>
              <S.TitlePrefixo>orçamento total</S.TitlePrefixo>
              <S.ResultadoCalculo>{formatDinheiro(extra.valorTotal, 2)}</S.ResultadoCalculo>
            </S.BoxCalculadoraWrapper>
            <S.BoxCalculadoraWrapper>
              <S.TitlePrefixo>resultado</S.TitlePrefixo>
              <S.ResultadoCalculo>
                {formatDinheiro(extra.resultadoFinal, 2)}
                {' %'}
              </S.ResultadoCalculo>
            </S.BoxCalculadoraWrapper>
          </S.BoxResultado>

          <ButtonPrimary label={'Remover do orçamento'} typeSubmit={false} onClick={() => removerProduto(id)} />
        </S.BoxAjusteWrapper>
      </S.BoxCalculadora>
    </S.ContainerWrapperCalculadora>
  );
};
export default ProdutoCarrinhoView;
